export default __webpack_public_path__ + "static/media/ssc-zdh.f8512300.png";